define(["jquery", "eventManager"], function ($, eventManager) {
    return {
        InitVideoModal: function (scope) {
            eventManager.subscribe("search:completed", function () {
                var $videoSrc;
                var $itemId;
                var $autoplay;
                $('.video-btn').on("click", function (e) {
                    $videoSrc = $(this).data("src");
                    $autoplay = $(this).data("autoplay");
                });

                $('.imgresponsivebtn').on("click", function (e) {
                    $videoSrc = $(this).data("src");
                    $autoplay = $(this).data("autoplay");
                });

                // when the modal is opened autoplay it
                $('#myModal').on('shown.bs.modal', function (e) {
                    $("#video").attr('src', $videoSrc + "?autoplay=" + $autoplay + ";rel=0&amp;showinfo=0&amp;modestbranding=1&amp");
                });

                // stop playing the youtube video when I close the modal
                $('#myModal').on('hidden.bs.modal', function (e) {
                    $("#video").attr("src", $("#video").attr("src").replace("autoplay=1", "autoplay=0"));
                });
            });
        }
    };
});